import { GenericComponent } from "../../components/GenericComponent";
import { useForm } from "react-hook-form";
import { useEffect, useRef, useState } from "react";
import { InputComponent } from "../../components/InputComponent";
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";
import { Card } from "primereact/card";
import { Toolbar } from "primereact/toolbar";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Generico } from "../../components/Generico";
import { Proceso } from "../../models/cliente/Proceso";
import { MonitoreoService } from "../../service/monitoreo/MonitoreoService";
import { Reprocesos } from "./Reprocesos";
import { useToken } from "../../components/useToken";

export const ProcesoCliente = () => {

    const generic = new GenericComponent();
    const omodel = new Proceso(true);
    const [permss, setPermss] = useState(null);
    const defaultValues = generic.default(omodel.model, null);
    const { control, formState: { errors }, handleSubmit, reset, setError, getValues } = useForm({ defaultValues });
    const [registers, setRegisters] = useState(null);
    const procesoSrv = new MonitoreoService()
    const { accionesTbl, stringToDate } = Generico();
    const [item, setItem] = useState(null);
    const [lista, setLista] = useState(null);
    const toast = useRef(null);
    const { getRol } = useToken();
    const [dialogProceso, setDialogProceso] = useState(false);
    const [catalogos, setCatalogos] = useState(null);
    const [opcion, setOpcion] = useState(null);
    const [dialogReproceso, setDialogReproceso] = useState(false);
    const { table, setLoading, setTotalRecords, lazyParams, inDrop, inComplete, inCalendar, inArea } =
        InputComponent({ registers, omodel, generic, errors, control, permss, id: getValues('id') });

    useEffect(() => {
        loadLazyData();
    }, [lazyParams]);

    const loadLazyData = () => {
        setLoading(true);
        let _lazyParams = lazyParams;
        delete _lazyParams.rtipo;
        if (permss == null) {
            _lazyParams.rtipo = true;
        }
        if (getRol()) {
            _lazyParams.rol = getRol();
        }
        procesoSrv.listado('admin-proceso-cliente/lista', { lazyEvent: JSON.stringify(_lazyParams) }).then(res => {
            setTotalRecords(res.data.total);
            setRegisters(res.data.registros);
            setLoading(false);
            if (res.data.perss !== undefined) {
                setPermss(res.data.perss);
                setCatalogos(res.data.catalogos);
                setOpcion(res.data.opcion);
            }
        });
    }

    const openNew = () => {
        setDialogProceso(true);
        reset(defaultValues);
    }

    const onSubmit = (data) => {
        data.fecha_inicio = data.fecha_inicio.toISOString().split('T')[0];
        data.fecha_fin = data.fecha_fin.toISOString().split('T')[0];
        if (getValues('id') == null) {
            procesoSrv.nuevo(data, 'admin-proceso-cliente/nuevo').then(res => {
                generic.funcSuccess(res, toast);
                setDialogProceso(false);
                loadLazyData();
            }).catch(error => {
                generic.funcError(error, toast, setError);
            });
        }
        else {
            procesoSrv.editar(data, 'admin-proceso-cliente/editar').then(res => {
                generic.funcSuccess(res, toast);
                setDialogProceso(false);
                loadLazyData();
            }).catch(error => {
                generic.funcError(error, toast, setError);
            });
        }
    }

    const editar = () => {
        procesoSrv.consultar(item?.id, 'admin-proceso-cliente/consulta').then(res => {
            const _proceso = res.data;
            if (_proceso.fecha_inicio) _proceso.fecha_inicio = stringToDate(_proceso.fecha_inicio);
            if (_proceso.fecha_fin) _proceso.fecha_fin = stringToDate(_proceso.fecha_fin);
            reset(generic.renewValues(_proceso, omodel.model));
            setDialogProceso(true);
        });
    };

    const confirmAction = (eeliminar) => {
        confirmDialog({
            message: eeliminar ? '¿Está seguro de eliminar el registro?' : '¿Está seguro de reprocesar?',
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            accept: () => eliminar(eeliminar)
        });
    }

    const eliminar = (eeliminar) => {
        setLoading(true);
        if (eeliminar) {
            procesoSrv.eliminar(item?.id, 'admin-proceso-cliente/eliminar').then(res => {
                loadLazyData();
                generic.funcSuccess(res, toast);
            }).catch(error => {
                generic.funcDeleteError(error, toast);
            }).finally(() => {
                setLoading(false);
            });
        } else {
            procesoSrv.editar({ id: item?.id }, 'admin-proceso-cliente/reproceso').then(res => {
                generic.funcSuccess(res, toast);
                setDialogProceso(false);
                loadLazyData();
            }).catch(error => {
                generic.funcError(error, toast, setError);
            }).finally(() => {
                setLoading(false);
            });
        }
    }

    const siOpcion = (strOpcion, permiso) => {
        return permiso && (opcion === 'PRELAFIT' || opcion.includes(strOpcion));
    }

    const itemsMenu = () => {
        const items = [];
        if (siOpcion('proceso-cliente-externo-editar', permss?.actualizar))
            items.push({ label: 'Editar', icon: 'pi pi-pencil', command: () => { editar() } });
        if (siOpcion('proceso-cliente-externo-reproceso', permss?.actualizar))
            items.push({ label: 'Reprocesar', icon: 'pi pi-replay', command: () => { confirmAction(false) } });
        if (permss?.consultar)
            items.push({ label: 'Historial', icon: 'pi pi-gauge', command: () => { setDialogReproceso(true) } });
        if (siOpcion('proceso-cliente-externo-eliminar', permss?.eliminar))
            items.push({ label: 'Eliminar', icon: 'pi pi-trash', command: () => { confirmAction(true) } });

        return [{ label: 'Opciones', items: items }];
    }

    const search = (event) => {
        if (!event.query.trim().length) {
            setLista([...lista]);
        } else {
            procesoSrv.autoLista('administracion/empresa-buscar/razon', event.query.toLowerCase()).then(data => {
                setLista(data);
            });
        }
    }

    return (
        <>
            <Toast ref={toast} />
            <ConfirmDialog />
            <Card style={{ maxWidth: '100%', margin: 'auto' }}>
                {siOpcion('proceso-cliente-externo-nuevo', permss?.crear) && <Toolbar className="mb-4" start={generic.leftToolbarTemplate(openNew, 'Nuevo', permss)}></Toolbar>}
                {table({ action01: accionesTbl, reg: setItem, items: itemsMenu() })}
            </Card>

            <Dialog visible={dialogProceso} header={getValues('id') == null ? "Nueva proceso" : "Editar proceso"} modal className="p-fluid modal-ssize" onHide={() => {
                setDialogProceso(false);
            }}
                style={{ maxWidth: '500px' }}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="formgrid grid">
                        {inComplete('empresa', lista, search, { hd: omodel.model.empresa.header, col: 12, obl: true, val: true, lab: 'nombre' })}
                        {inDrop('tipo_proceso', catalogos?.tipo, { lab: omodel.optionLabel }, 12)}
                        {inDrop('tipo_ejecucion', catalogos?.ejecucion, { lab: omodel.optionLabel }, 12)}
                        {inDrop('estado', catalogos?.estado, { lab: omodel.optionLabel }, 12)}
                        {inCalendar('fecha_inicio', {}, 6)}
                        {inCalendar('fecha_fin', {}, 6)}
                        {inArea('observacion', 3, 30, 12, { obl: '' })}
                    </div>
                    {generic.buttonsForms(setDialogProceso)}
                </form>
            </Dialog>

            <Dialog visible={dialogReproceso} header={"Historial procesos: " + item?.fecha_inicio + ' al ' + item?.fecha_fin} modal className="p-fluid modal-ssize"
                onHide={e => setDialogReproceso(false)} style={{ maxWidth: '900px' }}>
                {<Reprocesos id={item?.id} generic={generic} permss={permss} />}
            </Dialog>
        </>
    )
}
